"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var Slider_1 = require("@/pages/search/components/Slider");
var WindowApi_1 = require("@/api/browser/WindowApi");
exports.default = (function (props) {
    var item = props.item;
    var extraProps = {};
    if (props.index >= 0)
        extraProps["key"] = props.index;
    var renderPrimary = function (banner) {
        if (!banner.label)
            return "";
        var stripStyle = {};
        if (banner.bannerColour)
            stripStyle.backgroundColor = banner.bannerColour;
        if (banner.labelColour)
            stripStyle.color = banner.labelColour;
        var sm = (props.lang === "en" && banner.label.length > 12) ||
            (props.lang.indexOf("zh") > -1 && banner.label.length > 8);
        var classnames = classnames_1.default([
            "c-result__stripe",
            {
                "c-result__stripe--sm": sm,
            },
        ]);
        return (React.createElement("div", { className: classnames, style: stripStyle }, banner.label));
    };
    var renderSize = function (item) {
        if (!item.sizeSaleable && !item.sizeGross)
            return;
        var saGfa = !item.sizeSaleable ? props.t.gross : props.t.saleable;
        return (React.createElement("div", { className: "c-result__amenity" },
            React.createElement("div", { className: "c-result__amenity-value" },
                React.createElement("span", { className: "c-result__amenity-value--bold" }, format_1.default.size(item.sizeSaleable ? item.sizeSaleable : item.sizeGross)),
                React.createElement("span", { className: "c-result__amenity-value--caption" },
                    props.t.sqft,
                    " (",
                    saGfa,
                    ")"))));
    };
    var renderPricePerSqft = function (gross, saleable, symbol) {
        var renderPricePerSqftSize = function (price, saGfa) { return (React.createElement("div", { className: "c-result__pps" },
            React.createElement("div", { className: "c-result__pps-text" }, "@ " + format_1.default.currencyPpsf(price, symbol) + " / " + props.t.sqft + " (" + saGfa + ")"))); };
        if (saleable)
            return renderPricePerSqftSize(saleable, props.t.saleable);
        if (gross)
            return renderPricePerSqftSize(gross, props.t.gross);
    };
    var renderBeds = function (item) {
        var bedroomAmenities = item.amenities.filter(function (it) { return it.key === "bed"; });
        if (!bedroomAmenities || !bedroomAmenities.length)
            return;
        var bedroomAmenity = bedroomAmenities[0];
        return (React.createElement("div", { className: "c-result__amenity" },
            React.createElement("div", { className: "c-result__amenity-value" },
                React.createElement("span", { className: "c-result__amenity-value--bold" }, bedroomAmenity.value),
                React.createElement("span", { className: "c-result__amenity-value--caption" }, props.t.bd))));
    };
    var renderBaths = function (item) {
        var bathroomAmenities = item.amenities.filter(function (it) { return it.key === "bath"; });
        if (!bathroomAmenities || !bathroomAmenities.length)
            return;
        var bathroomAmenity = bathroomAmenities[0];
        return (React.createElement("div", { className: "c-result__amenity" },
            React.createElement("div", { className: "c-result__amenity-value" },
                React.createElement("span", { className: "c-result__amenity-value--bold" }, bathroomAmenity.value),
                React.createElement("span", { className: "c-result__amenity-value--caption" }, props.t.ba))));
    };
    var enquireClicked = function (e) {
        if (props.onEnquireClicked)
            props.onEnquireClicked(item);
    };
    var favClicked = function (e) {
        if (props.onFavClicked)
            props.onFavClicked(item);
    };
    var buttonClass = classnames_1.default([
        "c-result__action-btn",
        {
            "c-result__action-btn--active": item.isSaved,
        },
    ]);
    var heartBtn = !item.isSaved ? "fal fa-heart" : "fas fa-heart";
    var renderFavButton = function () {
        if (props.item.isSaving) {
            return (React.createElement("button", { id: "result-item-fav-" + item.referenceId, className: "c-result__action-btn" },
                React.createElement("span", { className: "fal fa-sync u-rotate" })));
        }
        return (React.createElement("button", { id: "result-item-fav-" + item.referenceId, onClick: favClicked, className: buttonClass },
            React.createElement("span", { style: { pointerEvents: "none" }, className: heartBtn })));
    };
    var doMouseDown = function (e) {
        if (Array.from(e.target.classList).indexOf("fal") >= 0) {
            return;
        }
        if (props.onMouseDown)
            props.onMouseDown(props.item);
    };
    var doMouseUp = function (e) {
        if (Array.from(e.target.classList).indexOf("fal") >= 0) {
            return;
        }
        if (props.onMouseUp)
            props.onMouseUp(props.item);
    };
    var onMouseEnter = function (e) {
        props.onMouseEnter ? props.onMouseEnter(props.item) : null;
    };
    var onMouseLeave = function (e) {
        props.onMouseLeave ? props.onMouseLeave(props.item) : null;
    };
    var slugBuildingName = props.item.buildingNameEng || props.item.building;
    var url = "";
    url = propertyToUrl_1.propertyToUrl(props.lang, slugBuildingName, props.item.referenceId, props.filterType);
    var renderImages = function (images, item, noPhoto, googleApi, lazy, notAvailable) {
        if (images && images.length && !notAvailable) {
            return React.createElement(Slider_1.slider, { lazy: lazy, images: images, nameNoPhoto: noPhoto });
        }
        if (item.lat && item.lng && !notAvailable) {
            // tslint:disable-next-line:max-line-length
            var srcWide = "https://maps.googleapis.com/maps/api/staticmap?center=" + item.lat + "," + item.lng + "&zoom=16&size=640x480&markers=color:red|" + item.lat + "," + item.lng + "&key=" + googleApi;
            return (React.createElement("div", { className: "c-result__nopic", style: { backgroundImage: "url(" + srcWide + ")" } }));
        }
        return (React.createElement("div", { className: "c-result__nopic" },
            React.createElement("span", { className: "c-result__nopic-text" }, noPhoto)));
    };
    var renderStripePrimary = function (item, props) {
        return item.banners && item.banners.length
            ? renderPrimary(item.banners[0])
            : "";
    };
    var renderInc = function (item, includeText, excludeText) {
        if (item.includeManagementFee &&
            item.includeManagementFee.toUpperCase() === "E") {
            return React.createElement("div", { className: "c-result__currency" }, excludeText);
        }
        if (item.includeManagementFee &&
            item.includeManagementFee.toUpperCase() === "I") {
            return React.createElement("div", { className: "c-result__currency" }, includeText);
        }
    };
    var renderPriceSection = function (item, props) {
        var rederBuyPrice = function (item, props) { return (React.createElement("div", { className: "c-result__current-wrapper tid-salePrice" },
            React.createElement("div", { className: "c-result__current-text" }, item.salePrice
                ? format_1.default.currencySale(item.salePrice, props.lang, props.symbol)
                : ""))); };
        var rederLeasePrice = function (item, props) {
            var symbol = item.type === SfilterTypeGroup_1.SfilterType.BUYRENT
                ? props.justAgent
                    ? ""
                    : props.symbol.slice(-1)
                : props.symbol;
            return (React.createElement("div", { className: "c-result__current-wrapper" },
                React.createElement("div", { className: "c-result__current-text tid-leasePrice" }, item.leasePrice
                    ? format_1.default.currencyLease(item.leasePrice, props.lang, symbol)
                    : ""),
                renderInc(item, props.t.include, props.t.exclude)));
        };
        if (item.isSubjectToOffer) {
            return (React.createElement("div", { className: "c-result__current-wrapper" },
                React.createElement("div", { className: "c-result__current-text c-result__current-text--sm" }, props.t.subjectToOffer)));
        }
        if (props.notAvailable) {
            return (React.createElement("div", { className: "c-result__current-wrapper" },
                React.createElement("div", { className: "c-result__current-text c-result__current-text--sm" }, props.t.offMarket)));
        }
        return (React.createElement(React.Fragment, null,
            item.type === SfilterTypeGroup_1.SfilterType.BUYRENT || item.type === SfilterTypeGroup_1.SfilterType.BUY
                ? rederBuyPrice(item, props)
                : null,
            item.type === SfilterTypeGroup_1.SfilterType.BUYRENT || item.type === SfilterTypeGroup_1.SfilterType.RENT
                ? rederLeasePrice(item, props)
                : null));
    };
    var renderPpsfSection = function (item, props) {
        var pricePerSqftGross = props.filterType === SfilterTypeGroup_1.SfilterType.BUY
            ? item.salePricePerSqftGross
            : item.leasePricePerSqftGross;
        var pricePerSqftSaleable = props.filterType === SfilterTypeGroup_1.SfilterType.BUY
            ? item.salePricePerSqftSaleable
            : item.leasePricePerSqftSaleable;
        if (item.isSubjectToOffer || item.price <= 0)
            return "";
        return renderPricePerSqft(pricePerSqftGross, pricePerSqftSaleable, "");
    };
    var renderExtraIcon = function (item) {
        return item.isVirtual || item.isVideo ? (React.createElement("div", { className: "c-result__virtual" },
            item.isVideo ? React.createElement("span", { className: "fas fa-camera-movie" }) : null,
            item.isVirtual ? (React.createElement("img", { loading: "lazy", src: "/res/img/360icon-selected.png", alt: "" })) : null)) : ("");
    };
    var clickAttr = {};
    if (item.districtId) {
        if (props.onDistrictClicked) {
            clickAttr.onClick = function (e) {
                e.stopPropagation();
                e.preventDefault();
                props.onDistrictClicked(item.area, item.districtId);
                return false;
            };
        }
        // tslint:disable-next-line: max-line-length
        clickAttr.href = "/" + props.lang + "/district/" + format_1.default.normalize(item.area) + "/" + item.districtId;
    }
    var renderPicDiv = function () {
        var images = item.images.map(function (it, i) {
            var price = item.isSubjectToOffer || item.price === 0
                ? props.t.subjectToOffer
                : "" + format_1.default.currency(item.price, props.symbol);
            var sqft = "" + format_1.default.comma(item.size) + props.t.sqft;
            var name = item.building;
            var type = props.t[SfilterTypeGroup_1.SfilterType.toString(item.type)];
            var newCaption = price + " " + sqft + " " + name + " " + type;
            return __assign(__assign({}, it), { caption: newCaption });
        });
        var content = (React.createElement(React.Fragment, null,
            renderImages(images, item, props.t.noPhoto, props.googleApi, props.lazy, props.notAvailable),
            props.sold || props.notAvailable ? null : renderExtraIcon(item)));
        return item.images.length ? (React.createElement("div", { className: "c-result__pic", onMouseDown: doMouseDown, onMouseUp: doMouseUp }, content)) : props.sold ? (React.createElement("div", { className: "c-result__pic" }, content)) : (React.createElement("a", { className: "c-result__pic", href: WindowApi_1.toAbsoluteUrl(url) }, content));
    };
    var onClicked = function (e) {
        if (["button", "a"].indexOf(e.target.tagName.toLowerCase()) >= 0)
            return;
        if (props.notAvailable)
            return;
        props.notAvailable ? null : props.onItemClicked(item);
    };
    var renderDate = function (props) {
        return (React.createElement("div", { className: "c-result__foot" },
            React.createElement("div", { className: "c-result__update" },
                props.t.lastUpdated,
                ":",
                " ",
                format_1.default.date(new Date(item.lastUpdated)))));
    };
    var renderAgent = function (props) {
        return (React.createElement("div", { className: "c-result__agent" },
            React.createElement("div", { className: "c-result__agent-img" },
                React.createElement("img", { "data-src": props.item.agentImage, alt: props.item.agentName })),
            React.createElement("div", { className: "c-result__agent-name" }, props.item.agentName)));
    };
    var renderAddressAndPpsf = function (props) {
        return (React.createElement("div", { className: "c-result__row" },
            React.createElement("div", { className: "c-result__row-left" },
                React.createElement("div", { className: "c-result__address" }, item.address)),
            React.createElement("div", { className: "c-result__row-right" }, renderPpsfSection(item, props))));
    };
    var renderActions = function (props) {
        return (React.createElement("div", { className: "c-result__actions" },
            React.createElement("div", { className: "c-result__action-group" },
                React.createElement("div", { className: "c-result__action-cell c-result__fav" }, renderFavButton()),
                React.createElement("div", { className: "c-result__action-cell", style: { display: props.notAvailable ? "none" : "block" } },
                    React.createElement("button", { id: "result-item-enquire-" + item.referenceId, onClick: enquireClicked, className: "c-result__action-btn" },
                        React.createElement("span", { className: "fal fa-envelope" }),
                        React.createElement("span", { className: "c-result__action-text" }, props.t.contact))))));
    };
    var resultItemClass = classnames_1.default([
        "c-result__item",
        { "c-result__item--agent": props.justAgent && props.item.agentImage },
    ]);
    var renderRowLayout = function (props) {
        return (React.createElement("div", { className: "c-result__main" },
            React.createElement("div", { className: "c-result__row" },
                React.createElement("div", { className: "c-result__row-left" },
                    React.createElement("a", { href: WindowApi_1.toAbsoluteUrl(url), target: "_blank", className: "c-result__building", style: { cursor: "pointer" } }, item.building)),
                React.createElement("div", { className: "c-result__row-right" }, renderPriceSection(item, props))),
            props.justAgent || props.sold ? null : renderAddressAndPpsf(props),
            React.createElement("div", { className: "c-result__row" },
                React.createElement("div", { className: "c-result__row-left" },
                    React.createElement("div", { className: "c-result__address" }, item.area)))));
    };
    var renderColLayout = function (props) {
        var soldStyle = props.sold
            ? { textDecoration: "none", color: "#000" }
            : {};
        return (React.createElement("div", { className: "c-result__main" },
            React.createElement("div", { className: "c-result__cols" },
                React.createElement("div", { className: "c-result__col c-result__col--left" },
                    React.createElement("div", { className: "c-result__row" },
                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl(url), target: "_blank", className: "c-result__building", style: __assign({ cursor: "pointer" }, soldStyle) }, item.building)),
                    React.createElement("div", { className: "c-result__row" },
                        React.createElement("div", { className: "c-result__address" }, props.justAgent || props.sold ? null : item.address)),
                    React.createElement("div", { className: "c-result__row" },
                        React.createElement("div", { className: "c-result__address" }, item.area))),
                React.createElement("div", { className: "c-result__col c-result__col--right" },
                    React.createElement("div", { className: "c-result__row" },
                        React.createElement("div", { className: "c-result__col" }, renderPriceSection(item, props))),
                    React.createElement("div", { className: "c-result__row" }, props.justAgent || props.sold || props.notAvailable
                        ? null
                        : renderPpsfSection(item, props))))));
    };
    return (React.createElement("div", __assign({ className: resultItemClass }, extraProps),
        React.createElement("div", { className: "c-result__item-body" },
            renderPicDiv(),
            React.createElement("div", { className: "c-result__body" },
                React.createElement("div", { className: "c-result__info", onClick: onClicked, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
                    props.justAgent ? renderRowLayout(props) : renderColLayout(props),
                    React.createElement("div", { className: "c-result__meta" },
                        React.createElement("div", { className: "c-result__meta-group" },
                            React.createElement("div", { className: "c-result__amenities" },
                                props.sold ? null : renderSize(item),
                                props.justAgent || props.sold ? null : renderBeds(item),
                                props.justAgent || props.sold ? null : renderBaths(item))),
                        props.justAgent || props.sold ? null : renderActions(props)),
                    props.justAgent || props.sold || props.notAvailable
                        ? null
                        : renderDate(props)),
                props.justAgent && props.item.agentImage ? renderAgent(props) : null),
            renderStripePrimary(item, props))));
});
